import { get } from 'lodash';
import { itemGridColumn, itemGridSpacer, } from '../../sections/section-item-grid/css-classes';
export function getItemGridSmallScreenCss(_a) {
    var css = _a.css;
    return getItemGridColumnPaddingsForSmallScreenCss({ css: css });
}
export function getItemGridColumnPaddingsForSmallScreenCss(_a) {
    var css = _a.css;
    var spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    return "\n  ." + itemGridColumn + " > table > tbody > tr > td {\n    padding: 0!important;\n  }\n\n  ." + itemGridColumn + " {\n    padding-bottom: " + spacerHeight + "px!important;\n    padding-top: " + spacerHeight + "px!important;\n  }\n\n  ." + itemGridSpacer + " div {\n    height: " + spacerHeight + "px!important;\n  }\n  ";
}
//# sourceMappingURL=get-item-grid-section-style.js.map